// extracted by mini-css-extract-plugin
export var actualRow = "my-surveys-module--actual-row--oJx8K";
export var item = "my-surveys-module--item--ytcAP";
export var list = "my-surveys-module--list--CHppB";
export var separator = "my-surveys-module--separator--WldjP";
export var title = "my-surveys-module--title--HzW+N";